import * as React from "react";
import Svg, { Path } from "react-native-svg";

function AddUserWhite(props) {
  return (
    <Svg width={30} height={30} viewBox="0 0 30 30" fill="none" {...props}>
      <Path
        d="M18.75 15c2.762 0 5-2.238 5-5 0-2.763-2.238-5-5-5s-5 2.237-5 5c0 2.762 2.238 5 5 5zM7.5 12.5V8.75H5v3.75H1.25V15H5v3.75h2.5V15h3.75v-2.5H7.5zm11.25 5c-3.338 0-10 1.675-10 5V25h20v-2.5c0-3.325-6.663-5-10-5z"
        fill="#fff"
      />
    </Svg>
  );
}

export default AddUserWhite;
